var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.20985 16.8317V4.23651C3.20985 3.85165 3.347 3.52231 3.6213 3.24848C3.8956 2.97465 4.22494 2.8375 4.60933 2.83704H15.8051C16.19 2.83704 16.5195 2.97418 16.7938 3.24848C17.0681 3.52278 17.205 3.85212 17.2046 4.23651V12.6333C17.2046 13.0182 17.0677 13.3478 16.7938 13.6221C16.52 13.8963 16.1904 14.0333 15.8051 14.0328H6.0088L3.20985 16.8317ZM8.3879 11.2339L10.2072 9.41455L12.0265 11.2339L13.0062 10.2542L11.1868 8.43492L13.0062 6.61561L12.0265 5.63598L10.2072 7.45529L8.3879 5.63598L7.40827 6.61561L9.22758 8.43492L7.40827 10.2542L8.3879 11.2339Z",
    fill: "#573B76",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6596,
    height: 16.3272,
    fill: "white",
    transform: "translate(0.877365 0.115967)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.07212e421f3e748fafb742b418d001db.svg";
export { ForwardRef as ReactComponent };